/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { hot } from "react-hot-loader/root";
import { BrowserRouter as Router } from "react-router-dom";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import AppLayout from "./AppLayout";

export default hot(
  React.memo(function App() {
    const [isInitialized, setIsInitialized] = useState(false);
    const formatMessage = useFormatMessage();
    useEffect(() => {
      document.title = formatMessage(messageIds.app.name);
    }, [formatMessage]);

    useEffect(() => {
      setIsInitialized(true);
    }, []);

    return isInitialized ? (
      <Router>
        <AppLayout />
      </Router>
    ) : (
      <Spin
        css={css`
          margin-top: 50vh;
          margin-left: 100vh;
        `}
      />
    );
  })
);
